import { currentTimestamp } from "@/config/store/StoreItemsModule/helpers"

export default () => ({
  ADD_ITEM(state, { item, prepend = false }) {
    item._addedAt = `t_${currentTimestamp()}`
    prepend ? state.items.unshift(item) : state.items.push(item)
  }
})
